import { useAppSelector } from "../../../app/store";
import CameraIcon from "../../../assets/icons/CameraIcon";
import UserImg from "../../../assets/images/empty_user.jpg";
import useModal from "../../../hooks/useModal";
import AddUserPhotoModal from "./AddUserPhotoModal";

export default function UploadProfileImage() {
  const {
    open: openAddPhotoModal,
    handleOpen: handleAddPhotoOpen,
    handleClose: handleAddPhotoClose,
  } = useModal<undefined, "ADD_PHOTO">();
  const { user } = useAppSelector((state) => state.auth);

  return (
    <>
      {openAddPhotoModal.type === "ADD_PHOTO" && (
        <AddUserPhotoModal
          handleClose={handleAddPhotoClose}
          open={openAddPhotoModal.open}
        />
      )}

      <div className="w-24 h-24 relative select-none">
        <img
          className="w-full h-full rounded-full"
          src={user?.data?.photo || UserImg}
          alt=""
        />
        <div
          onClick={() => handleAddPhotoOpen({ type: "ADD_PHOTO" })}
          className="w-[22px] h-[22px] right-0 top-[72px] absolute bg-[#f2f6fa] rounded-full border border-white inline-flex justify-center items-center text-body-text cursor-pointer"
        >
          <CameraIcon />
        </div>
      </div>
    </>
  );
}
